export default __webpack_public_path__ + "static/media/kayak.60e41031.jpg";